import { minite } from "./minites.filter.js";
import { formatSeconds, toPrecision, discriminationNameFilter, degreeOfDifficultyNameFilter, dateFormat } from "./utils.filter.js";
import { NumberToUpperCase } from "./numberToUpperCase.filter.js";
export const FilterInit = (Vue) => {
  minite(Vue);
  formatSeconds(Vue);
  toPrecision(Vue);
  discriminationNameFilter(Vue);
  degreeOfDifficultyNameFilter(Vue);
  dateFormat(Vue)
  NumberToUpperCase(Vue);
};
